import { MdOutlineArrowRightAlt, MdOutlineWarning } from 'react-icons/md';
import { StatisticsItemType } from '@lp/features/MultiSuggest';
import { STATISTICS_TYPE_NAMES } from '@lp/features/MultiSuggest/utils';
import { DeviationInfo } from '@lp/features/MultiSuggest/components/MultiSuggestResult/DeviationInfo';
import { RouteLegTypeEnum } from '@/api/apis/route';

const PROVIDER_NAME: Partial<Record<RouteLegTypeEnum, string>> = {
  [RouteLegTypeEnum.TmdxJetAviaLeg]: 'TMDX',
  [RouteLegTypeEnum.SupplementalLiftAviaLeg]: 'SLP',
  [RouteLegTypeEnum.TxCenterProviderAviaLeg]: 'TX',
  [RouteLegTypeEnum.TmdxAffiliateGroundLeg]: 'TMDX Affiliate',
  [RouteLegTypeEnum.TmdxDriveAffiliateGroundLeg]: 'TMDX Affiliate',
  [RouteLegTypeEnum.TxCenterProviderGroundLeg]: 'TX',
  [RouteLegTypeEnum.SelfServicedGroundLeg]: 'Self-Serviced',
};

type StatisticsItemProps = {
  data: StatisticsItemType;
};

export const StatisticsItem = ({ data }: StatisticsItemProps) => {
  const STATISTICS_ITEM_NAME = STATISTICS_TYPE_NAMES[data.type];

  return (
    <div className="flex flex-col gap-1">
      <div className="flex gap-2 items-center">
        <span className="text-l-r text-base-5">{STATISTICS_ITEM_NAME}</span>
        <div className="flex gap-1 items-center">
          <span className="text-l-sb text-base-10">{data.changes.oldValue}</span>
          {!!data.changes.newValue && (
            <>
              <MdOutlineArrowRightAlt size={16} />
              <span className="text-l-sb text-base-10">{data.changes.newValue}</span>
            </>
          )}
          {!!data.delta && <DeviationInfo value={data.delta.value} isNegative={data.delta.isNegative} />}
          {!!data.isWarning && (
            <div className="text-warning-30">
              <MdOutlineWarning size={16} />
            </div>
          )}
        </div>
      </div>
      {data.children?.map((c) => {
        return (
          <div key={c.type} className="flex gap-2 items-center ml-2">
            <span className="text-l-r text-base-5">{PROVIDER_NAME[c.type] || ''}</span>
            <div className="flex gap-1 items-center">
              <span className="text-l-sb text-base-10">{c.oldValue}</span>
              {!!c.newValue && (
                <>
                  <MdOutlineArrowRightAlt size={16} />
                  <span className="text-l-sb text-base-10">{c.newValue}</span>
                </>
              )}
              {!!c.delta && <DeviationInfo value={c.delta.value} isNegative={c.delta.isNegative} />}
            </div>
          </div>
        );
      })}
    </div>
  );
};
